/* eslint-disable max-len */
export default {
  lang: 'Japanese',
  homeScreen: {
    title: 'Discover Big Things',
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  loginScreen: {
    version2: {
      homeTitle:
        '私たちのシステムで、あなたの既存のプロフィールが見つかるか確認してみましょう。',
      homeTitleSub:
        'トレーニングプログラムへのログインに通常使用するメールアドレスを入力してください。',
      noAccount:
        'アカウントが見つかりません({email})。別のメールアドレスで試すか、今すぐアカウントを作成してください。',
      continueButton: '続ける',
      success:
        'アカウントの更新に成功しました！まもなくホームページに移動します。',
      successNewAccount:
        '登録を完了するには、アカウントを確認するための確認メールが送信されます。',
      loginButton: 'ログイン',
      matchFound:
        '一致する情報が見つかりました。パスワードを入力して次に進んでください。',
      magicLink: 'Eメールのリンクからログインしてください：',
      magicLinkButton: 'マジックリンクのリクエスト',
      magicLinkTitle:
        'あなたのEメールに直接リンクが送られ、すぐにサインインできます。',
      otherEmailButton: '投稿する',
      title:
        'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      titleIndustry:
        'あなたの個人プロフィールと連絡先情報が入力されますので、以下のすべての情報を入力してください。',
      register: 'アカウントの作成',
      agent: 'トラベル・アドバイザー',
      visitor: '業界ビジター',
      step1: 'ステップ1：ユーザーのタイプ',
      step2: 'ステップ 2: アカウントの作成',
      step3: 'ステップ3：プロフィールの作成',
      marketingOptIn:
        'このプログラムのトラベル・トレード・チームとのつながりを維持することに興味はありませんか？',
      optIn: 'はい、興味があります',
      optOut: '興味なし',
      step2Sub1: 'あなた自身について教えてください',
      step2Sub2: 'あなたのビジネスについて教えてください',
      privacyHead: '通信設定',
      privacySub:
        '以下のボックスにチェックを入れると、サプライヤーの旅行業界チームからの重要な連絡（商品の最新情報やお知らせ、特典、インセンティブ、FAMなど）や、TravPRO Mobileからの旅行業界ネットワーキングや営業支援イニシアチブを確実に受け取ることができます。',
      privacy:
        '当社はお客様のプライバシーを保護し、お客様の信頼を売り渡したり、悪用したり、裏切ったりすることは決してありません。',
      store: 'アプリストアで簡単にダウンロードできます：',
      powered: 'パワー・バイ',
      toastMessage: {
        forgotSuccess:
          'パスワードリセットリンクをEメールで送信しました！10秒後にログインページにリダイレクトされます。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
        magicLinkMessage:
          '今、サインインしているところですので、お待ちください。',
        magicLinkError:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkError1:
          '有効なトークンが見つかりませんでした。ログインするか、新しいマジックリンクをリクエストしてください。この問題が解決しない場合は、info@travpromobile.com。',
        magicLinkError2:
          'データベースにお客様のアカウントが見つかりませんでした。手動でログインしてください。10秒後にリダイレクトされます。',
        magicLinkSuccess:
          'email}でメールをチェックしてください。魔法のリンクでサインインできます。',
        magicLinkErrorWait:
          'マジックリンクリクエストの間は5分間お待ちください。',
        emailNotFoundError:
          '入力されたメールアドレスが当社の記録にありません。スペルミスをチェックするか、アカウントを作成してください。',
      },
      errors: {
        zipCodeNotFound: '郵便番号が見つかりません。',
        zipCodeOnlyNumbers: 'ZipCode には数字のみを含めることができます。',
        password: 'パスワードを入力してください',
        passwordNotMatching: '入力したパスワードが一致しません。',
        passwordTooShort: 'パスワードは8文字以上',
        emailExists:
          'このメールアドレスは既に存在するか、無効です。別のメールアドレスで試すか、アカウントにログインしてください。',
        fillInAllFields: '必須項目をすべてご記入ください。',
        fillInEmail: 'Eメールをご記入ください。',
        emailNotExisting: '入力されたEメールアドレスが存在しません。',
      },
      fields: {
        forgotSubCopy: 'パスワードをお忘れですか？',
        forgotSubCopy2:
          'パスワードを完全に回避したいですか？自動的にプログラムにログインできる魔法のリンクをメールでお送りします。',
        city: '都市',
        companyName: '会社名',
        role: 'あなたの役割',
        description: '御社の事業内容を最もよく表しているのはどれですか？',
        country: '国名',
        password: 'パスワード',
        passwordRegister: 'パスワードの選択（最低8文字）',
        passwordConfirm: 'パスワードの確認',
        firstName: 'ファーストネーム',
        lastName: '姓（家族）',
        agency: '代理店名',
        title: 'あなたの役割（1つを選択）',
        company: '会社名',
        select: '以下のオプションを選択してください。',
        state: '州',
        province: '都道府県',
        zipCode: '郵便番号',
        postalCode: '郵便番号',
        affiliate: '主な所属事務所はどのグループですか？',
        hostAgency: 'ホスト・エージェンシー？',
        executive: 'エグゼクティブ',
        management: 'マネジメント',
        marketing: 'マーケティング',
        sales: '売上高',
        coordinator: 'コーディネーター',
        opt: 'このプログラムのトラベル・トレード・チームと連絡を取り合い、最新情報を受け取る。',
        optMarketing:
          '同様のプログラムやイベントに関して、TravPROと連絡を取り合ってください。',
        retail: '店舗フロント',
        home: '在宅エージェント',
        independent: 'インディペンデント・コントラクター',
        host: 'ホスト・エージェンシー',
        call: 'コールセンターまたはウェブベースの代理店',
        other: 'その他',
        describes:
          'あなたやあなたの代理店の事業を最もよく表しているものは何ですか？',
      },
    },
    forgot: 'パスワードを忘れた？',
    forgotCopy:
      'フィンランド旅行PROアカウントにサインアップしたときに使用したメールアドレスを入力してください。 パスワードをリセットできるメールをお送りします。」',
    country: '国/地域*',
    select: '以下のオプションを選択してください',
    theme: 'あなたが主に販売している製品テーマは何ですか？ *',
    type: 'あなたが主に販売している製品テーマは何ですか？ *',
    businessType: 'ビジネスの種類*',
    title: 'Travel Professional Training and Sales Enablement Program',
    welcome: {
      headerTop: 'Finland Travel Proへようこそ',
      headerBottom: '',
    },
    sellingPoints: {
      0: '外出先で学び、宣伝し、販売する',
      1: 'デバイス間のマルチメディアトレーニング',
      2: '修了証',
      3: '既製の販売プレゼンテーション',
      4: 'インパクトのある販促資料',
      5: 'インサイダーのヒントとプロモーション',
      6: 'リアルタイム製品ディレクトリ',
      7: 'タイムリーなニュースとアップデート',
    },
    emailPrompt:
      'あなたが旅行の専門家であることを確認するためにあなたのメールアドレスとパスワードを入力してください。',
    tAndC: {
      agree: '続行することにより、あなたは私たちに同意します',
      privacyPolicy: 'プライバシーポリシー',
      and: 'と',
      termsConditions: '規約と条件',
    },
    fields: {
      agency: 'エージェンシー',
      email: 'Eメール *',
      password: 'パスワード*',
      passwordConfirm: 'あなたのパスワードを確認 *',
      firstName: 'ファーストネーム *',
      lastName: '苗字 *',
      city: '市 *',
      agencyName: '代理店名*',
      stateProvince: '州/県',
      required: '必須',
      invalidEmail:
        '連絡を取り合いましょう！ はい、Finland Travel PROからの通信にオプトインしたいと思います。これにより、ニュース、イベント、インセンティブ、FAMなどに投稿できます。',
      opt: '私はエージェントではありません',
      forgot:
        'パスワードをお忘れですか？下のボタンをクリックすると、パスワードをリセットするためのメールをお送りします。',
    },
    noAgent: {
      noAgentButton: '私はアドバイザーではありません',
      title: '「このサイトのコンテンツは、旅行の専門家専用です。',
      messageWeb: '  フィンランドの詳細については、次のURLをご覧ください',
      messageMobile:
        'このアプリの一部のコンテンツは旅行の専門家専用ですが、[続行]を押して、このアプリが提供するもののプレビューを自由に閲覧してください。',
      continue: '継続する',
      visitWebsite: 'ウェブサイトを訪問',
    },
    newUser: '新しいユーザー',
    register: '登録',
    registered: 'このEメールはすでに登録されています',
  },
  welcomeScreen: {
    title: '「ようこそ Finland Travel PRO',
    helloUser: 'XX様',
    hello: 'こんにちは。',
    fromAgency: 'XXより',
    notUser: 'XXではない?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'おめでとうございます！',
    downloader: {
      preload: '事前にダウンロード',
      stop: '中止',
      init: 'Initializing...',
      lastUpdate: '最新更新',
    },
  },
  trainingScreens: {
    start: '開始',
    continue: '継続',
    review: 'レビュー',
    restart: '再起動',
    durationInMinutes: '{number}分',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: '継続',
    endReached: 'このモジュールの終わりに到達しました',
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: '前のページに戻って、もう一度トライしてみてください！',
    confirm: '回答を確認',
    choose: '回答を選んでください',
    skip: '前のページ',
    viewAllTitle: 'トレーニングヒント',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: '空欄に記入してください：',
    next: '次の問題',
    retry: 'もう一度トライしてみる',
    fastTrackText: {
      success:
        'おめでとうございます。ファストトラックコースに合格し、残りのトレーニングのロックを解除しました。',
      failed:
        '残念ながら、ファストトラックコースに合格しなかったため、トレーニングを再開して卒業証書を取得できます。',
    },
    fastTrack:
      'スイス旅行のスーパースターになろう！ （フィンランドトラベルPRO）',
    fastTrackExplanation:
      '「次のページのクイズに答えて、スイス（フィンランド）へのFAMを獲得するチャンスを手に入れましょう！<br> <br> <spanstyle = \\ font-weight：bold\\>クイズのすべての回答が見つかります次の方法で質問します。</span><br><br>1。レイルヨーロッパとスイスのモジュールで学習したコンテンツ<br><br>2。次のウェブサイト：<br> <a href = \\ https://www.myswitzerland.com \\ target = \\ _ blank \\> www.myswitzerland.com </a> <br> <a href = https://www.bucherer.com \target = _ blank > www.bucherer.com </a> <br> <a href=\\https://www.mysts.net\\target=\\_blank\\>www.mysts。 net </a> <br> <br> <span style = \\ font-weight：bold \\>クイズに答える前に、これらのリソースを詳細に確認してください。スコアが最も高い人だけが受験する機会があります。 FAMに招待されます。</span>」',
    fastTrackButton:
      'スイスのスーパースタークイズに参加するには、ここをクリックしてください',
    grading: '最終成績は次のとおりです。{grade}％',
  },
  nav: {
    home: '家',
    train: 'Learn',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Showcases',
    showcases: 'Showcases',
    promote: 'Promote',
    sell: 'Sell',
    info: '情報',
    rewards: '報酬',
    media: 'メディア',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'アカウント設定',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Learn',
    retain: 'Retain',
    subapps: 'フィンランドパートナーモジュールにアクセス',
    maintrainings: 'The Foundation',
    subtrainings: 'スペシャライゼーションモジュール',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote:
      'Answer client questions and close the sale like a pro with deep resources and targeted sales support.',
    sell: 'お客様の質問に回答し、商談をまとめるために必要な奥深い情報をご覧いただけます。',
    favorites: '個人的にお気に入りのコンテンツをチェックしてください',
    search: 'すべてのコンテンツに目を通す',
    subapps: '',
    maintrainings: 'Complete these essential modules to earn your certificate.',
    subtrainings: '特定の製品について学ぶ',
  },
  directory: {
    city: 'Filter by City',
    search: 'Search for a product',
    product: 'Filter by Product Type',
    reset: 'Reset Filters >',
    category: 'Filter by Category',
    season: 'Filter by Season',
    noResults: 'No Results Found',
    target: 'Filter by Target Group',
    additional: 'Additional Filters',
    sustainable: 'Sustainable Travel Finland',
    accessible: 'Accessible',
    results: 'Results',
  },
  contactView: {
    regions: {
      europe: 'Europe',
      northAmerica: 'North-America',
      asiaPacific: 'Asia Pacific',
      fcb: 'FCB - Finland Convention Bureau',
    },
    jobTitles: {
      salesMarketing: 'Sales & Marketing Manager',
      directorVisitFinland: 'Director of Visit Finland (Dach & Benelux)',
      specialist: 'Specialist',
      accountManager: 'Account Manager',
      advisor: 'Advisor',
      headVisitFinlandNorthAmerica: 'Head of Visit Finland North America',
      managerBusinessEvents: 'Manager, Business Events',
      seniorBusinessEvents: 'Senior Business Events Specialist',
    },
    countries: {
      gbIreland: 'Great Britain & Ireland',
      spainItaly: 'Spain & Italy',
      france: 'France',
      westEurope:
        'Germany, Austria, Switzerland, Belgium, Netherlands, Luxembourg',
      benelux: 'Dach, Benelux',
      rusiaCISBaltics: 'Baltics',
      rusiaCIS: 'Russia & CIS',
      northAmerica: 'North America',
      japan: 'Japan',
      chinaSEAsia: 'Greater China & South East Asia',
      southKorea: 'South Korea',
      india: 'India & UAE',
      australia: 'Australia',
    },
  },
  general: {
    viewBadge: '表示',
    viewBadge2: 'バッジ',
    back: '戻る',
    next: '次',
    yes: 'はい',
    no: '番号',
    previous: '戻る',
    page: 'ページ',
    search: '検索',
    logIn: 'ログイン',
    logOut: 'ログアウト',
    viewItem: '{type}を表示',
    imageNotFound: '画像が見つかりません',
    noResultsFor: '{{query}}の結果は見つかりませんでした',
    noFavorites: 'まだお気に入りはありません。',
    noMessages: 'まだメッセージを受信していません！',
    resultsFor: '結果：{{query}}',
    showAll: 'すべて表示する',
    connectionError: '接続エラー',
    alreadyExists: 'もう存在している',
    pageNotFound: '404ページが見つかりません！',
    oops: 'ええとああ...',
    overview: '概要に戻る',
    complete: '継続する',
    courseComplete: 'モジュール完了！',
    chapterComplete: 'モジュール完了！',
    message: '{count}メッセージ',
    messagePlural: '{count}メッセージ',
  },
  itemTypes: {
    image: '画像',
    brochure: 'コレクション',
    layout: 'レイアウト',
    web: 'Webサイト',
    pdf: 'PDF',
    carousel: 'コレクション',
  },
  questions: {
    dials: '答えに一致するようにダイヤルを回転させます',
    fitb: '空欄に記入してください',
    flip: '答えに一致するように番号を変更します',
    multipleChoice: '正しい答えを選んでください',
    slider: 'スライダーを使用して正しい答えを選択してください',
    map: '地図上の適切な場所をタップして質問に答えます',
    dropdown: '選ぶ...',
    true: '真',
    false: '誤り',
  },
  reportCard: {
    download: 'ダウンロード',
    email: 'Eメール',
    print: '印刷',
  },
  cookies: {
    consent: '同意',
    optout: '身を引く',
    settings: 'プライバシー設定',
    message:
      'あなたはあなたのデータプライバシー設定について何も教えてくれませんでした！ 大丈夫ですが、セールスコンパニオンを使用して最高の体験を提供したいと思います。',
    disabled: 'Cookieの使用を無効にしたようです。',
    use: '{{appName}}では、最高のエクスペリエンスを提供するためにCookieを使用する必要があります。',
    details: 'クッキーは何に使用されますか？',
    enable: 'Cookieを有効にする方法をご覧ください{{here}}。',
    here: 'ここ',
  },
  notLoggedIn: {
    super: 'ログインしていません',
    title: 'このコンテンツを表示するには、ログインする必要があります',
    guest: 'ゲスト',
  },
  demo: {
    message:
      'このウェブサイトは最終製品のデモです。 現在開発中であり、完全な製品ではありません。',
    consent: '了解した！',
  },
  share: {
    header: 'SNSにシェア',
    download: 'ダウンロード',
    emailSubject: 'フィンランドのリソース',
    emailCopy:
      'このフィンランドのリソースをお楽しみください。 連絡を取り、次の旅行の計画を始めましょう！',
    videoEmailSubject: 'このフィンランドのビデオをお楽しみください',
    videoEmailCopy:
      'このフィンランドのビデオをお楽しみください。 連絡を取り、次の旅行の計画を始めましょう！',
    imageEmailSubject: 'このフィンランドの画像をお楽しみください',
    imageEmailCopy:
      'このフィンランドのイメージを楽しんでいただければ幸いです。 連絡を取り、次の旅行の計画を始めましょう！',
    twitterCopy: 'フィンランドのビッグシングスを発見',
  },
  sharing: {
    copyURL: 'リンクをコピー',
    copied: 'コピー',
  },
  breadCrumbs: {
    page: 'ページ',
  },
  onMobile: {
    header:
      'モバイルデバイスから{appName}アプリにアクセスしようとしているようです',
    body: 'このプログラムをダウンロードするには、アプリストアにアクセスして{appName}を検索するか、下のボタンの1つをクリックしてください。',
    benefits: {
      1: '外出先で学び、宣伝し、販売する',
      2: 'デバイス間のマルチメディアトレーニング',
      3: '修了証',
      4: '既製の販売プレゼンテーション',
      5: 'インパクトのある販促資料',
      6: 'リアルタイム製品ディレクトリ',
      7: 'タイムリーなニュースとアップデート',
      header: 'これにより、次のことが提供されます。',
    },
  },
  custom: {
    splitUsers: '私は ...',
    brandAmbassador: 'ブランドアンバサダー',
    travelPro: '旅行の専門家',
  },

  submit: '確認',
  back: '戻る',
  close: '閉じる',
  directoryFilters: {
    cities: '都市別にフィルター',
    search: '商品を検索',
    type: '商品タイプ別にフィルター',
    reset: 'フィルターをリセット >',
    tags: 'タグ別にフィルター',
    months: '季節別にフィルター',
    noResults: '結果が見つかりません',
    targetGroups: '対象グループ別にフィルター',
    additional: '追加フィルター:',
    sustainable: 'サステナブルなフィンランド旅行',
    accessible: 'アクセス可能',
    results: '結果',
  },
  search: {
    pages: 'ページ',
    resources: 'リソース',
  },
};
